import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./sidebar";

const RestaurantMyProfileLayout = () => {
  return (
    <>
    <div>
        <Sidebar />
        <Outlet />
    </div>
    </>
  );
};
export default RestaurantMyProfileLayout;
